export default __webpack_public_path__ + "static/media/token-icon-4.8c1c3769.svg";